import React, { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

const ROLES = ["admin", "readonly"];

const CreateUserModal = ({ open, onClose, onSubmit, loading }) => {
  const [form, setForm] = useState({
    username: "",
    email: "",
    role: "readonly",
  });

  const handleChange = (field) => (e) =>
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = () => {
    onSubmit(form);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 1,
        },
      }}
    >
      {/* HEADER */}
      <DialogTitle sx={{ p: 2 }}>
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" gap={2} alignItems="center">
            <Avatar sx={{ bgcolor: "primary.main" }}>
              <PersonAddIcon />
            </Avatar>

            <Box>
              <Typography fontWeight={700}>
                Create User
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Add a new user to the system
              </Typography>
            </Box>
          </Box>

          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      {/* CONTENT */}
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField
          label="Username"
          fullWidth
          onChange={handleChange("username")}
        />

        <TextField
          label="Email"
          fullWidth
          type="email"
          onChange={handleChange("email")}
        />

        <TextField
          select
          label="Role"
          value={form.role}
          onChange={handleChange("role")}
        >
          {ROLES.map((r) => (
            <MenuItem key={r} value={r}>
              {r}
            </MenuItem>
          ))}
        </TextField>
      </DialogContent>

      {/* ACTIONS */}
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>

        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? <CircularProgress size={18} /> : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateUserModal;